import * as types from 'models/actionTypes'

const initialState = {
    quickPreviewIsOpen: false,
    isCurrentDragValid: true,
    isMagicWindowLoading: false,
    initialLoading: false,
    wallDataDimensions: {
        width: 0,
        height: 0,
    },
    settings: {
        showOcclusions: true,
        showShadows: true,
        showSurfaces: [],
        magicEraserMode: false,
        wallCollisions: false,
    },
}

const preview = (state = initialState, action) => {
    switch (action.type) {
        case types.QUICK_PREVIEW_ART:
            return {
                ...state,
                quickPreviewIsOpen: true,
            }
        case types.QUICK_PREVIEW_CLOSE:
            return {
                ...state,
                quickPreviewIsOpen: false,
            }
        case types.DRAG_VALIDITY_CHANGE:
            return {
                ...state,
                isCurrentDragValid: action.isValid,
            }
        case types.UPDATE_PREVIEW_SETTINGS:
            return {
                ...state,
                settings: {
                    ...state.settings,
                    ...action.settings,
                },
            }
        case types.SHOW_PLACEABLE_SURFACES:
            return {
                ...state,
                settings: {
                    ...state.settings,
                    showSurfaces: action.surfaces,
                },
            }
        case types.HIDE_PLACEABLE_SURFACES:
            return {
                ...state,
                settings: {
                    ...state.settings,
                    showSurfaces: [],
                },
            }
        case types.SET_MAGIC_WINDOW_LOADING:
            return {
                ...state,
                isMagicWindowLoading: action.isMagicWindowLoading,
            }
        case types.SET_INITIAL_LOADING:
            return {
                ...state,
                initialLoading: action.initialLoading,
            }
        case types.WALLDATA_READY:
            return {
                ...state,
                wallDataDimensions: {
                    width: action.wallDataWidth,
                    height: action.wallDataHeight,
                },
            }
        default:
            return state
    }
}

export default preview
